module.exports = __webpack_public_path__ + "img/cover-grading-bg-mobile.1991e673.jpg";